import { SignIn } from '@clerk/clerk-react';

import QalicoLogo from '@/assets/qalico-logo.svg?react';
import signin from '@/assets/signin.png';

export default function SignInPage() {
  return (
    <div className="flex min-h-screen">
      {/* Left side - Sign In Form */}
      <div className="flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:w-1/2 lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div className="mb-8">
            <div className="flex items-center space-x-2">
              <QalicoLogo />
            </div>
            <p className="mt-6 text-sm text-muted-foreground">
              Welcome back! Please sign in to your account.
            </p>
          </div>
          <SignIn
            appearance={{
              elements: {
                footerAction: { display: 'none' },
              },
            }}
          />
        </div>
      </div>
      {/* Right side - Illustration */}
      <div className="relative hidden lg:block lg:w-1/2">
        <div className="absolute inset-0 h-full w-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
          {/* Placeholder for illustration */}
          <div
            className={`w-full h-full bg-cover bg-center`}
            style={{ backgroundImage: `url('${signin}')` }}
          />
        </div>
      </div>
    </div>
  );
}
